/**
 * @description 앱(native)이 웹뷰 브릿지를 호출했을 때 발생하는 에러를 예외 처리하기 위한 함수
 */
export const initInterfaceBetweenSocarAppAndSocarWebBridge = () => {
  if (!window.interfaceBetweenSocarAppAndSocarWeb) {
    window.interfaceBetweenSocarAppAndSocarWeb = {}
  }

  window.interfaceBetweenSocarAppAndSocarWeb.onViewportChanged = () => {}
  window.interfaceBetweenSocarAppAndSocarWeb.updateVisitedHistory = () => {}
  window.interfaceBetweenSocarAppAndSocarWeb.onPause = () => {}
  window.interfaceBetweenSocarAppAndSocarWeb.onResume = () => {}
}
